<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import SalesDeliverySummaryContent from '../components/SalesDeliverySummaryContent.vue';
import { useSalesTransactionDetail } from '../composables/useSalesTransactionDetail';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const transactionId = computed(() => route.params.salesTransactionId);
const detail = useSalesTransactionDetail({ id: transactionId, t });

const routeParams = role => ({
  accountId: route.params.accountId,
  salesTransactionId: transactionId.value,
  ...(role ? { partyRole: role } : {}),
});
const goBack = () =>
  router.push({
    name: 'operacao_imobiliaria_vendas_entregar',
    params: routeParams(),
    query: route.query,
  });
const edit = section => {
  const routes = {
    imovel: ['operacao_imobiliaria_vendas_cadastro_imovel'],
    vendedores: ['operacao_imobiliaria_vendas_cadastro_partes', 'vendedor'],
    compradores: ['operacao_imobiliaria_vendas_cadastro_partes', 'comprador'],
    comissao: ['operacao_imobiliaria_vendas_comissao'],
  };
  const [name, role] = routes[section] || [];
  if (name) router.push({ name, params: routeParams(role) });
};
</script>

<template>
  <div class="min-h-full bg-lais-bg-soft">
    <section
      v-if="detail.error.value"
      class="mx-auto flex min-h-64 max-w-[1280px] flex-col items-center justify-center px-4 text-center"
    >
      <p class="text-sm text-lais-danger">{{ detail.error.value }}</p>
      <LaisPrimaryButton class="mt-4" variant="ghost" @click="goBack">
        {{ t('SALES.ACTIONS.BACK') }}
      </LaisPrimaryButton>
    </section>
    <SalesDeliverySummaryContent
      v-else-if="detail.loading.value || detail.transaction.value"
      :loading="detail.loading.value"
      :transaction="detail.transaction.value || {}"
      @back="goBack"
      @edit="edit"
    />
  </div>
</template>
